<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Suchergebnisse
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper" ref="contentWrapper">
      <product-list :renderData="renderData" v-if="!isLoading"/>
      <v-container class="lastArticlesWrapper" v-if="isLoading">

        <v-row
            class="articleCardRow"
        >
          <v-col cols="12"
                 class="articleCardCol"
                 v-for="index in 4"
                 :key="index"
          >
            <v-card class="articleCard"
                    elevation="0"
                    v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                    light
            >
              <v-list-item three-line class="skeletonWrapper__li">
                <v-skeleton-loader class="skeletonAvatar" type="avatar">

                </v-skeleton-loader>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                      >
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <div class="articleAdditionalInfoWrapper">
                        <v-col cols="12" class="pb-0 pt-2">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                      </div>
                      <v-col cols="12" class="articleStatus">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="pa-0 articlePriceMain">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import ProductList from "@/app/productListing/productList";
import router from "@/router";
import {mapState} from 'vuex'
import axios from 'axios'

export default {
  name: "articleResults",

  components: {ProductList},
  data() {
    return {
      renderData: {cart: false, category: true, products: [], name: null},
      isLoading: true,
    }
  },

  methods: {
    goBack() {
      router.go(-1)
    },

    createProductsList() {
      if(this.searchResultsArticles === null) {
        router.push({name: 'LastArticle'})
      }
      else {
        this.isLoading = true


        if(!this.searchResultsArticles || this.searchResultsArticles.length === 0) {
            let param = {searchTerm: this.$route.params.searchTerm, queryGTIN: this.$route.params.queryGTIN}
            axios.post('api/searchArticles', param)
                .then((result) => {
                    this.renderData.products = result.data
                    this.isLoading = false
                })
        } else {
            let param = {articles: this.searchResultsArticles}
            axios.post('api/searchArticles', param)
                .then((result) => {
                    // rearrange the artices
                    let originalIdOrder = this.searchResultsArticles.map(obj => obj.itemNo)
                    let sortedResult = result.data.sort((a,b) => {
                        if(a.delisted !== b.delisted) {
                            return a.delisted ? 1 : -1
                        }

                        const aIndex = originalIdOrder.indexOf(a.itemNo)
                        const bIndex = originalIdOrder.indexOf(b.itemNo)
                        return aIndex - bIndex
                    })
                    this.renderData.products = sortedResult
                    this.isLoading = false
                })
        }

        /*
        axios.post('api/searchArticles', param)
            .then((result) => {
              this.renderData.products = result.data
              this.isLoading = false
            })
         */

        this.$nextTick(function () {
          this.$refs["contentWrapper"].addEventListener('scroll', this.onScroll)
          this.onScroll

          if(this.currentPosition !== null) {
            this.$refs["contentWrapper"].scrollTo(0, this.currentPosition)
          }
          else {
            this.$refs["contentWrapper"].scrollTo(0, 0)
          }
        })
      }
    }
  },

  created() {
    this.createProductsList()
  },

  computed: {
    ...mapState({
      searchResultsArticles: 'searchResultsArticles',
      currentPosition: 'currentPosition'
    }),
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },

  beforeRouteUpdate(to, from, next) {
    this.createProductsList()
    next()
  },
}
</script>

<style>

</style>
